import {useContext, useEffect, useState} from "react";
import MDBox from "../../components/MDBox";
import CustomerHeader from "../common/CustomerHeader";
import Footer from "../Footer";
import CustomerPageLayout from "../Layout/CustomerPageLayout";
import Grid from "@mui/material/Grid";
import {CompanyContext} from "../../lib/CompanyProvider";
import GiftCardsMiniPane from "./pane/GiftCardsMiniPane";
import Meta from "../common/Meta";
import {getPreferenceValue} from "../common/Utils";

export default function CustomerGiftCards(props) {
  const [companyContext, setCompanyContext] = useContext(CompanyContext);

  const [company, setCompany] = useState(companyContext?.company);

  useEffect(() => {
    if (companyContext?.company?.guid) {
      setPageReady(true);
      setCompany(companyContext.company);
    }
  }, [companyContext?.company]);

  const [pageReady, setPageReady] = useState(false);

  return (
    <>
      <CustomerPageLayout>
        <Meta pageTitle={'Gift Cards'}/>
        <CustomerHeader props={props}/>

        {pageReady && <MDBox>
          <MDBox m={3}>
            <Grid container cols={3} spacing={3} direction="row">
              <Grid item sm={12} xs={12}>
                <h1>
                  {companyContext?.company?.preferences && getPreferenceValue(companyContext?.company?.preferences, 'menu_item_gift_card', 'Gift Cards')}
                </h1>
                <GiftCardsMiniPane/>
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
        }

        <Footer/>
      </CustomerPageLayout>
    </>
  )
}